import all from './all';
import deletes from './delete';
import fetch from './fetch';
import edit from './edit';
import create from './create';
import deleteEmployee from './deleteEmployee';
import editOrAddEmployee from './editOrAddEmployee';
import uploadEmployee from './uploadEmployee';
import uploadBanner from './uploadBanner';
import fetchAllAdmin from './fetchAllAdmin';
import addAdmin from './addAdmin';
import fetchSearchEmployee from './fetchSearchEmployee';
import fetchAllPackage from './fetchAllPackage';
import fetchTags from './fetchTags';
import fetchCorporateCategoryChoices from './fetchAllCorporateCategoryChoice';
import fetchAdminList from './fetchAdminList';

export default {
  all,
  deletes,
  fetch,
  create,
  edit,
  deleteEmployee,
  editOrAddEmployee,
  uploadEmployee,
  uploadBanner,
  fetchAllAdmin,
  addAdmin,
  fetchSearchEmployee,
  fetchAllPackage,
  fetchTags,
  fetchCorporateCategoryChoices,
  fetchAdminList,
};
